/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import * as yup from 'yup'

const ValidationSchema = () => {
  return yup.object().shape({
    name: yup
      .string()
      .trim()
      .max(255, 'Name must be less than 255 characters')
      .required('Required')
      .default(() => ''),
    sharingWith: yup
      .array()
      .when('schedulingEnabled', {
        is: true,
        then: (schema: any) => schema.required('Sharing is required when scheduling is enabled')
      })
      .nullable()
  })
}

export default ValidationSchema
